import React from 'react';
import { Trans } from 'react-i18next';

import { P3 } from '../../DesignSystem/Text';

export const Divider = ({ sectionTitle }) => (
    <>
        <div style={{ width: '90%', margin: '3px auto', height: '1px', background: '#DFE3E8' }} />
        {Boolean(sectionTitle) && (
            <P3 style={{ margin: '8px 0 2px 10px', color: '#919EAB' }}>
                <Trans>{sectionTitle}</Trans>
            </P3>
        )}
    </>
);